import { OnboardingMainComponent } from "./main/main.component";

export const containers: any[] = [OnboardingMainComponent];

export * from "./main/main.component";
